import DoneSection from 'components/account/Returns/DoneSection';
import { PROVIDE_LABEL_OPTIONS } from 'constants/exchanges';
import useMartyContext from 'hooks/useMartyContext';

const ReturnConfirmationTitle = ({
  isPrivateLabel,
  showReturnInstructionsBoxes,
  className,
  labelDelivery,
  boxInfo,
  rmaId,
  postReturnInfo,
  isLabelless
}) => {
  const { testId } = useMartyContext();
  if (isPrivateLabel) {
    return null;
  }

  if (showReturnInstructionsBoxes && labelDelivery !== PROVIDE_LABEL_OPTIONS.MAIL) {
    return (
      <div className={className}>
        <h1 data-test-id={testId('heading')}>Your Return Request Confirmation</h1>
      </div>
    );
  }

  if (labelDelivery !== PROVIDE_LABEL_OPTIONS.PICKUP) {
    return <DoneSection postReturnInfo={postReturnInfo} isLabelless={isLabelless} boxInfo={boxInfo} />;
  }

  if (labelDelivery === PROVIDE_LABEL_OPTIONS.PICKUP) {
    return (
      <div className={className}>
        <h1 data-test-id={testId('heading')}>Your Return Request Confirmation</h1>
        {rmaId && (
          <p>
            <span data-test-id={testId('returnConfId')}>Confirmation ID:</span> {rmaId}
          </p>
        )}
      </div>
    );
  }

  return null;
};

export default ReturnConfirmationTitle;
